import { render, staticRenderFns } from "./JourneyGroupItem.vue?vue&type=template&id=a97258e8&scoped=true&"
import script from "./JourneyGroupItem.vue?vue&type=script&lang=js&"
export * from "./JourneyGroupItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97258e8",
  null
  
)

export default component.exports